import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServiceSidebar from './ServiceSidebar';
import './Service.css';

const IVFService = () => {
  return (
    <div className="service-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>IVF Treatment in Ambala | Test Tube Baby Centre | Amaanat IVF</title>

        <meta
          name="description"
          content="Get advanced IVF treatment in Ambala at Amaanat IVF Clinic. High success rates, expert fertility specialists, and affordable test tube baby treatment."
        />

        <meta
          name="keywords"
          content="IVF treatment in Ambala, test tube baby centre, fertility clinic Ambala, IVF success rate, ICSI treatment"
        />

        <link rel="canonical" href="https://amaanativf.com/services/ivf" />

        {/* ✅ Medical Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalProcedure",
            "name": "IVF Treatment",
            "description": "In Vitro Fertilization treatment for infertility",
            "procedureType": "Therapeutic",
            "bodyLocation": "Uterus",
            "location": {
              "@type": "MedicalClinic",
              "name": "Amaanat IVF",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Ambala",
                "addressCountry": "India"
              }
            }
          })}
        </script>

        {/* ✅ FAQ Schema (RANKING BOOST) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is IVF treatment?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "IVF (In Vitro Fertilization) is a fertility treatment where eggs and sperm are combined in a lab to create embryos and then transferred to the uterus."
                }
              },
              {
                "@type": "Question",
                "name": "What is the success rate of IVF?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "IVF success rates vary but can reach up to 70-75% depending on patient condition, age, and clinic expertise."
                }
              },
              {
                "@type": "Question",
                "name": "Is IVF painful?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "IVF is mostly painless. Some procedures like egg retrieval are done under sedation to ensure comfort."
                }
              },
              {
                "@type": "Question",
                "name": "How long does IVF take?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "A complete IVF cycle usually takes around 4-6 weeks from stimulation to pregnancy test."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <section className="service-hero">
        <div className="container">

          <h1 className="hero-title">
            IVF Treatment in Ambala
          </h1>

          <p className="hero-subtitle">
            In Vitro Fertilization (Test Tube Baby Treatment) with high success rates
          </p>
{/* 
          <div className="hero-stats">
            <span>100%+</span> Success Rate
          </div> */}
        </div>
      </section>

      {/* MAIN */}
      <div className="services-layout container">

        <ServiceSidebar />

        <div className="services-content">

          {/* Process */}
          <section className="process-section">

            <h2 className="section-title">
              Step-by-Step IVF Treatment Process
            </h2>

            <div className="steps-grid">

              <div className="step">
                <div className="step-number">01</div>
                <h3>Ovarian Stimulation</h3>
                <p>Hormone injections for 10-12 days to produce multiple eggs</p>
              </div>

              <div className="step">
                <div className="step-number">02</div>
                <h3>Egg Retrieval Procedure</h3>
                <p>Ultrasound-guided egg collection under sedation (20 mins)</p>
              </div>

              <div className="step">
                <div className="step-number">03</div>
                <h3>Fertilization in Lab</h3>
                <p>Eggs and sperm combined in advanced IVF lab</p>
              </div>

              <div className="step">
                <div className="step-number">04</div>
                <h3>Embryo Development</h3>
                <p>Embryos monitored for 3-5 days until blastocyst stage</p>
              </div>

              <div className="step">
                <div className="step-number">05</div>
                <h3>Embryo Transfer</h3>
                <p>Embryos placed into uterus (painless procedure)</p>
              </div>

              <div className="step">
                <div className="step-number">06</div>
                <h3>Pregnancy Test</h3>
                <p>Blood test after 10-12 days to confirm pregnancy</p>
              </div>

            </div>
          </section>

          {/* ✅ SEO TEXT BLOCK (Hidden Ranking Booster) */}
          <section style={{ marginTop: "40px" }}>
            <h2>Best IVF Centre in Ambala</h2>
            <p>
              Amaanat IVF is one of the leading IVF centres in Ambala offering advanced fertility treatments including IVF, ICSI, and IUI.
              Our experienced doctors and modern lab facilities ensure higher success rates and personalized care for every couple.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default IVFService;